import { Button, Tooltip, Typography } from "@mui/material";
import { useState } from "react";

import HNSColors from "../../../../../../../ui library/HNSColors";
import AssociateDocumentsWrapper from "../AssociateDocumentsWrapper";

export default function CaseAccordionDetail({ accordionItemContent }) {
  const documents = accordionItemContent?.data?.documents ?? [];
  const [openAssociateAppointmentsModal, setOpenAssociateAppointmentsModal] = useState();
  const [selectedDocument, setSelectedDocument] = useState(null);

  const handleAssociateDocument = (document) => {
    setSelectedDocument(document);
    setOpenAssociateAppointmentsModal(true);
  };

  return (
    <div>
      {documents.map((document) => (
        <div className="flex flex-row items-center justify-between p-2">
          <Tooltip title={document.name}>
            <div className="max-w-96">
              <Typography className="overflow-hidden text-ellipsis text-sm">
                {document.name}
              </Typography>
            </div>
          </Tooltip>
          <Button
            sx={{
              background: HNSColors.secondary[500],
              "&:hover": {
                background: HNSColors.secondary[600],
              },
            }}
            className="inline-flex items-center justify-center gap-2 rounded-[500px] px-[18px] py-[10px] text-center font-['Roboto'] text-[14px] font-semibold normal-case leading-none tracking-normal text-white !shadow-none"
            variant="contained"
            disableElevation
            onClick={() => handleAssociateDocument(document)}
          >
            Associate Appointments{" "}
          </Button>
        </div>
      ))}
      {selectedDocument && (
        <AssociateDocumentsWrapper
          document={selectedDocument}
          openAssociateAppointmentsModal={openAssociateAppointmentsModal}
          handleCloseAssociateAppointmentModal={setOpenAssociateAppointmentsModal}
        />
      )}
    </div>
  );
}
